import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { Fragment } from "react";

import { Image } from "@/components/Product/ProductImage/imageWrapper/image/image.component";
import { EmptyImages } from "@/utils/enums";
import { doesVideoThumbnailNeedOverlay } from "@/utils/imageViewer";

export interface ProductMedia {
    thumbnail?: string;
    maxZoom?: string;
    main?: string;
    zoom?: string;
    altText?: string | null;
    videoId?: string;
}

type Props = {
    media: ProductMedia;
    defaultVideoThumbnailPath?: string;
    lazyLoad?: boolean;
};

const SlideThumbnail = ({
    media,
    defaultVideoThumbnailPath,
    lazyLoad
}: Props) => {
    const imageUrl =
        (media.videoId ? media.thumbnail : media.main) ||
        defaultVideoThumbnailPath;

    if (!imageUrl) return <Fragment />;

    return (
        <>
            {media.videoId && doesVideoThumbnailNeedOverlay(media.main) && (
                <div className="imageViewer-overlay" />
            )}
            <Image
                className={"h-100 mh-100"}
                lazyLoad={lazyLoad}
                parentFit={false}
                altText={media.altText}
                defaultImageUrl={EmptyImages.Size_146_109}
                medias={[
                    {
                        altText: media.altText,
                        url: imageUrl,
                        format: ProductImageRendition.XS
                    }
                ]}
                rendition={ProductImageRendition.XS}
            />
        </>
    );
};

export { SlideThumbnail };
